import React from 'react';
import { AiSvg } from 'src/assets/dynamicSvg';
import { Poppins } from 'src/common';
import CheckBox from 'src/components/form/CheckBox';
import * as S from './SuggestModifiersChecker.styles';

export { Wrap } from './SuggestModifiersChecker.styles';

interface SuggestModifiersCheckerProps {
  isDisabledModSuggest: boolean;
  addRecommendedModifiers: boolean;
  setAddRecommendedModifiers: (value: boolean) => void;
}

export const SuggestModifiersChecker: React.FC<SuggestModifiersCheckerProps> = ({
  isDisabledModSuggest,
  addRecommendedModifiers,
  setAddRecommendedModifiers,
}) => {
  return (
    <S.Wrap
      onClick={isDisabledModSuggest ? undefined : () => setAddRecommendedModifiers(!addRecommendedModifiers)}
      $disabled={isDisabledModSuggest}
    >
      <CheckBox isChecked={addRecommendedModifiers} disabled={isDisabledModSuggest} />
      <AiSvg isActive={!isDisabledModSuggest} />
      <Poppins px={14} weight={500} data-cy="suggest-modifiers-checker">
        Do you want to apply the suggested modifiers?
      </Poppins>
    </S.Wrap>
  );
};
